const FETCH_SUPERSET_REPORT_DETAILS_BEGIN = 'FETCH_REPORT_DETAILS_BEGIN';
const FETCH_SUPERSET_REPORT_DETAILS_SUCCESS = 'FETCH_REPORT_DETAILS_SUCCESS';
const FETCH_SUPERSET_REPORT_DETAILS_ERROR = 'FETCH_REPORT_DETAILS_ERROR';
const FETCH_SUPERSET_TOKEN_BEGIN = 'FETCH_SUPERSET_TOKEN_BEGIN';
const FETCH_SUPERSET_TOKEN_SUCCESS = 'FETCH_SUPERSET_TOKEN_SUCCESS';
const FETCH_SUPERSET_TOKEN_ERROR = 'FETCH_SUPERSET_TOKEN_ERROR';

export default {
  FETCH_SUPERSET_REPORT_DETAILS_BEGIN,
  FETCH_SUPERSET_REPORT_DETAILS_SUCCESS,
  FETCH_SUPERSET_REPORT_DETAILS_ERROR,
  FETCH_SUPERSET_TOKEN_BEGIN,
  FETCH_SUPERSET_TOKEN_SUCCESS,
  FETCH_SUPERSET_TOKEN_ERROR,
};
